import jwtDecode from 'jwt-decode';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { CONFIG_UPDATE } from 'Reducers/config/types';
import { SET_ENV } from 'Reducers/env/types';
import { INITIALIZATION_ERROR } from 'Reducers/nav/types';
import { notifyApp } from 'Utilities/appCommunicator';
import { setUrls } from 'Utilities/dataHelpers';
import { createAuthSession, getAuthSession, persistAuthSession } from 'Utilities/session';
import { getSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
import { updateConfig } from 'Services/config';
import { waitForToken } from './appBridge';
import { getPatientService } from './libre_api';
const root = (pageCtx) => {
    return new Promise((resolve) => {
        const queryParams = pageCtx.query;
        setupInitialization(queryParams)
            .catch((err) => {
            if (store) {
                store.dispatch({
                    type: INITIALIZATION_ERROR,
                    initErrorStatus: err.status,
                });
            }
        })
            .finally(resolve);
    });
};
const setupInitialization = async (queryParams, forceCountry) => {
    const envSession = getSessionObject('env');
    const configSession = getSessionObject('config');
    const country = forceCountry ?? queryParams?.country;
    if (!queryParams && envSession && configSession) {
        store.dispatch({ type: CONFIG_UPDATE, config: configSession });
        store.dispatch({ type: SET_ENV, env: envSession });
        setUrls(configSession, country);
        return;
    }
    const { app, pId, osType, osVersion, appVersion } = queryParams || {};
    await updateConfig(country, app, pId, appVersion, osType, osVersion);
};
const setupLoginLogic = (resolve, pageCtx) => {
    let url = '/login';
    if (pageCtx.querystring) {
        url = url.concat(`?${pageCtx.querystring}`);
    }
    pageCtx.page.redirect(url);
    resolve();
};
/**
 * TEMPORARY: This function will be removed once the integration with the new APIs is completed.
 * It was created to allow the test team to test the Connected Apps Libre features before the API integration is finished.
 * URL path: /connections?deviceId={deviceId}&appVersion={appVersion}&osType={osType}&osVersion={osVersion}&app={app}&country={country}&token={token}
 *
 * @param token
 * @param queryParams
 * @returns
 */
const setupLibreLogic = async (queryParams) => {
    notifyApp('adc-webview:ready');
    const token = await waitForToken(queryParams?.token);
    const { app, country, pId, osType, osVersion, appVersion } = queryParams || {};
    await updateConfig(country, app, pId, appVersion, osType, osVersion);
    const decodedToken = jwtDecode(token);
    const patient = await getPatientService(decodedToken.id, token, osType, osVersion, app, appVersion);
    if (!patient) {
        return;
    }
    const authSession = createAuthSession(token, patient);
    store.dispatch({ type: AUTH_SESSION, authSession });
    persistAuthSession(authSession);
};
const protectedPageAction = (pageCtx) => {
    return new Promise((resolve) => {
        /**
         * TEMPORARY: This validation will be removed once the integration with the new APIs is completed.
         * It was created to allow the test team to test the Connected Apps Libre features before the API integration is finished.
         * URL path: /connections?deviceId={deviceId}&appVersion={appVersion}&osType={osType}&osVersion={osVersion}&app={app}&country={country}&token={token}
         */
        if (pageCtx.pathname === '/connections' && pageCtx.query?.app === 'libre1') {
            setupLibreLogic(pageCtx.query)
                .catch((err) => {
                if (store) {
                    store.dispatch({
                        type: INITIALIZATION_ERROR,
                        initErrorStatus: err.status,
                    });
                }
            })
                .finally(resolve);
            return;
        }
        const authSession = getAuthSession();
        if (!authSession) {
            setupLoginLogic(resolve, pageCtx);
            return;
        }
        store.dispatch({ type: AUTH_SESSION, authSession });
        const queryParams = pageCtx.query;
        setupInitialization(queryParams, authSession.user.country)
            .catch((err) => {
            if (store) {
                store.dispatch({
                    type: INITIALIZATION_ERROR,
                    initErrorStatus: err.status,
                });
            }
        })
            .finally(resolve);
    });
};
// Create your paths that you want to handle here
// you want to most specific earlier and the least specific later
// Note: if one action throws an error (calls promise reject) then the handlePaths
// will move onto the next matching route
const routeActions = [
    {
        regex: [
            /^\/connections/i,
            /^\/llu-pending-connection/i,
            /^\/llu-connection/i,
            /^\/llu-add-connection/i,
            /^\/lv-practice-connection/i,
            /^\/lv-practice-invitation/i,
            /^\/lds-connection/i,
            /^\/lv-add-practice/i,
            /^\/partner-add-connection/i,
            /^\/partner-connection/i,
            /^\/partner-confirm-connection/i,
        ],
        action: protectedPageAction,
    },
    {
        regex: [/^\.*/],
        action: root,
    },
];
export const handlePaths = (ctx) => {
    const doActions = [];
    for (const check of routeActions) {
        for (const r of check.regex) {
            if (ctx.canonicalPath.match(r)) {
                // Add valid actions to chain later
                doActions.push(check.action);
            }
        }
    }
    // Start with a rejected promise
    let p = Promise.reject();
    // Build a negative promise chain that will try the next action if the previous one failed
    // Once an action succeeds the chain ends and the app starts
    for (let i = 0; i < doActions.length; i++) {
        p = p.catch(() => doActions[i](ctx));
    }
    return p;
};
